import { render, staticRenderFns } from "./contest-quiz-section-create.html?vue&type=template&id=7625d94d&scoped=true&"
import script from "./contest-quiz-section-create.js?vue&type=script&lang=js&"
export * from "./contest-quiz-section-create.js?vue&type=script&lang=js&"
import style0 from "./contest-quiz-section-create.scss?vue&type=style&index=0&id=7625d94d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7625d94d",
  null
  
)

export default component.exports